import { type createRequest } from '@direct-frontend/modules-request';
import { API_BUSINESS_REQUEST_BASE_PATH } from './const';

type Options = Exclude<Parameters<typeof createRequest>[0], undefined>;

export const apiRequestCommon: Partial<Options> = {
    // Нет смысла делать ретраи, т.к. сейчас уже реализованы несколько ступеней ретраев — на балансере бекенда и на балансере фронтбека
    retry: 0,
    timeout: 60_000, // 1 минута

    // Для SSR надо прокидывать полный путь
    baseUrl: __API_ORIGIN__ + API_BUSINESS_REQUEST_BASE_PATH,
    credentials: 'include',
    agent: false,
};
